import { HttpClient } from '@kira-dancer/nadal'
import { useRuntimeConfig } from 'nuxt/app'
import { useUser } from '#lib/composables'
import { getDeviceHeaders } from '#lib/utils'

export const useHttpClient = () => {
  const environment = useRuntimeConfig()
  const httpClient = HttpClient
  const { os, device, browser } = getDeviceHeaders()
  const { gpToken, token } = useUser()

  httpClient.setConfigure({
    baseURL: environment.public.API_URL as string,
    headers: {
      os,
      device,
      browser,
      accept: 'application/json',
    },
  })

  httpClient.setRequestInterceptor((request) => {
    request.headers.token = token.value
    request.headers.gptoken = gpToken.value
    request.headers.accept = 'application/json'
    return request
  })

  httpClient.setResponseInterceptor((response) => {
    return response
  })
}
